import { input, inputSession } from '@convincely/utils/lib/services/input.js';
import { DataStorage } from '@convincely/utils/lib/services/storage.js';
import { defined, getDefinedFallback } from '@convincely/utils/lib/defined.js';
import { empty } from '@convincely/utils/lib/strings.js';
import { derived, writable } from '../../library.js';
import { Store } from '../../models/Store.js';
export class InputItem extends Store {
    /**
     * @param {string} name
     * @param {*} [initialValue]
     * @param {DataStorage} [storage]
     */
    constructor(name, initialValue, storage = input) {
        super();
        this.name = name;
        this.storage = storage instanceof DataStorage ? storage : new DataStorage(empty, false, storage);
        this.setStore(getDefinedFallback(this.storage._data[name], initialValue));
    }
    /**
     * @template T
     * @param {T} value
     * @return {T}
     */
    setter(value) {
        const { name, storage } = this;
        if (defined(value)) {
            storage.setItem(name, value);
        }
        else {
            this.remove();
        }
        return value;
    }
    remove() {
        const { name, storage } = this;
        this.set(null);
        storage.removeItem(name);
    }
}
/**
 * @type {object.<string, InputItem>}
 */
const stores = new WeakMap();
const inputContexts = [];
export const inputStores = {};
export const inputs = writable({});
export const inputSessions = writable({});
export const _inputs = {};
export const _inputSessions = {};
export function clearInputStores() {
    inputContexts.forEach((context) => {
        try {
            context.remove();
        }
        catch (e) {
            // error removing context
        }
    });
}
/**
 * @param {string} name
 * @param {*} [initialValue]
 * @param {DataStorage} [storageContext]
 * @param {boolean} persist
 * @return {InputItem}
 */
export function getInputStore(name, initialValue, storageContext = input, persist = false) {
    if (!stores.has(storageContext)) {
        stores.set(storageContext, {});
    }
    const storeRef = stores.get(storageContext);
    let context = storeRef[name];
    if (!defined(context)) {
        context = storeRef[name] = new InputItem(name, initialValue, storageContext);
        if (!persist) {
            inputContexts.push(context);
        }
    }
    if (storageContext === inputSession && !_inputSessions[name]) {
        context.subscribe((value) => {
            _inputSessions[name] = value === null ? undefined : value;
            inputSessions.set(Object.assign({}, _inputSessions));
        });
    }
    if (storageContext === input && !inputStores[name]) {
        inputStores[name] = context;
        context.subscribe((value) => {
            _inputs[name] = value === null ? undefined : value;
            inputs.set(Object.assign({}, _inputs));
        });
    }
    return context;
}
/**
 * @param {InputItem} store
 * @param {DataItems} items
 * @return {Array.<Readable.<DataItem>> | Readable.<DataItem>}
 */
export function getInputItemStore(store, items) {
    return derived(store, ($value) => {
        if (Array.isArray($value)) {
            return $value.map((value) => items.getByKey(value) || {});
        }
        else {
            return items.getByKey($value) || {};
        }
    });
}
for (const name of input.keys) {
    getInputStore(name);
}
//# sourceMappingURL=InputItem.js.map